<template>
  <div>
    <custom-actions :title="title">
      <template #header>
        <el-button class="mr10" type="primary" v-if="hasAdd" @click="onAdd">新增</el-button>
        <el-button class="mr10" type="primary" @click="onDownExcel">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="客户名称" prop="userName">
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="流水凭证单号" prop="depositNumber">
          <el-input clearable v-model="searchForm.depositNumber" placeholder="请输入流水凭证单号"></el-input>
        </el-form-item>
        <el-form-item label="工单状态" prop="depositStatus">
          <el-select filterable clearable v-model="searchForm.depositStatus" placeholder="请选择工单状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border :data="tableData">
        <!-- <el-table-column min-width="180" label="流水ID" prop="depositId"></el-table-column> -->
        <el-table-column min-width="120" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="流水凭证单号" prop="depositNumber"></el-table-column>
        <el-table-column min-width="120" label="审批状态" prop="approvalStatus">
          <template v-slot="{ row }">
            <el-tag type="warning" v-if="row.approvalStatus == '1'">业务员审批</el-tag>
            <el-tag type="warning" v-if="row.approvalStatus == '2'">财务审批</el-tag>
            <el-tag type="warning" v-if="row.approvalStatus == '3'">业务经理审批</el-tag>
            <el-tag type="success" v-if="row.approvalStatus == '4'">审批通过</el-tag>
            <el-tag type="danger" v-if="row.approvalStatus == '5'">审批驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="工单状态" prop="depositStatus">
          <template v-slot="{ row }">
            <el-tag type="warning" v-if="row.depositStatus == '1'">审批中</el-tag>
            <el-tag type="success" v-if="row.depositStatus == '2'">审批通过</el-tag>
            <el-tag type="danger" v-if="row.depositStatus == '3'">驳回作废</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="资金类型" prop="transactionType">
          <template v-slot="{ row }">
            <span v-if="row.transactionType === '1'">保证金</span>
            <span v-if="row.transactionType === '2'">货款</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="操作类型" prop="depositType">
          <template v-slot="{ row }">
            {{ depositTypeMap.get(row.depositType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="金额(元)" prop="depositChange"></el-table-column>
        <el-table-column min-width="160" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="270" label="操作" fixed="right">
          <template v-slot="{ row }">
            <!-- 创建后即可导出付款申请单，作废及非付款方向不显示。 -->
            <el-button type="text" v-if="hasDetail && row.depositType === '2' && row.depositStatus !== '3'"
              :disabled="paymentExporting" @click="exportPaymentApplication(row, false)">退款申请单 PDF</el-button>
            <el-button type="text" v-if="hasDetail"
              @click="$router.push('/fundmanage/detail?depositId=' + row.depositId)">详情</el-button>
            <el-button type="text" v-if="row.approvalStatus === '1' && hasApproval1"
              @click="onApproval(row)">审批</el-button>
            <el-button type="text" v-if="row.approvalStatus === '2' && hasApproval3"
              @click="onApproval(row)">审批</el-button>
            <el-button type="text" v-if="row.approvalStatus === '3' && hasApproval2"
              @click="onApproval(row)">审批</el-button>
            <el-button type="text" v-if="hasDelete" class="del-btn" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 审批 -->
    <ApprovalDialog urlType="1" :relatedId="rowId" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
      :showDlg="showDlg"></ApprovalDialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import paymentApplicationExport from '@/mixins/paymentApplicationExport'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import { depositType, transactionType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'

export default {
  name: 'BondRecord3',
  mixins: [keepAlive, paymentApplicationExport],
  components: { ApprovalDialog },

  data() {
    return {
      depositTypeMap: depositType,
      transactionTypeMap: transactionType,
      tableData: [],
      depositTypeList: mapToObjectArray(depositType),
      statusList: [
        {
          label: '审批中',
          value: '1'
        },
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '驳回作废',
          value: '3'
        }

      ],

      page: 1,
      total: 0,
      searchForm: {
        userName: '',
        depositType: '',
        transactionType: '',
        depositStatus: '',
        depositNumber: ''
      },
      userList: [],
      showDlg: false,
      rowId: ''
    }
  },
  computed: {
    depositType() {
      return this.$route.query.depositType
    },
    transactionType() {
      return this.$route.query.transactionType
    },
    title() {
      const types = this.transactionType + this.depositType
      let transactionTypeName = ''
      if (types === '11') {
        transactionTypeName = '保证金充值'
      } else if (types === '12') {
        transactionTypeName = '保证金退还'
      } else if (types === '13') {
        transactionTypeName = '保证金转货款'
      } else if (types === '21') {
        transactionTypeName = '货款充值'
      } else if (types === '22') {
        transactionTypeName = '货款退还'
      } else if (types === '23') {
        transactionTypeName = '货款转保证金'
      }
      return transactionTypeName
    },
    menuCode() {
      if (this.transactionType === '1' && this.depositType === '1') {
        return 'BZJCZ2'
      }
      if (this.transactionType === '1' && this.depositType === '2') {
        return 'BZJTH'
      }
      if (this.transactionType === '1' && this.depositType === '3') {
        return 'BZJZHK'
      }
      if (this.transactionType === '2' && this.depositType === '1') {
        return 'HKCZ'
      }
      if (this.transactionType === '2' && this.depositType === '2') {
        return 'HKTH'
      }
      if (this.transactionType === '2' && this.depositType === '3') {
        return 'HKZBZJ'
      }
      return ''
    },
    buttonList() {
      return this.$store.getters.getMenuByCode(this.menuCode)
      // return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasApproval1() {
      return this.buttonList.includes('ywyapproval')
    },
    hasApproval2() {
      return this.buttonList.includes('ywjlapproval')
    },
    hasApproval3() {
      return this.buttonList.includes('cwapproval')
    },
    hasDetail() {
      return this.buttonList.includes('detail')
    }
  },
  watch: {
    depositType() {
      this.searchForm.depositType = this.depositType
    },
    transactionType() {
      this.searchForm.transactionType = this.transactionType
    },
    title(val, oldVal) {
      if (val && oldVal) {
        this.onReset()
        this.onSearch()
      }
    }
  },
  created() {
    this.searchForm.depositType = this.depositType
    this.searchForm.transactionType = this.transactionType
    this.loadUserList()
    this.loadData()
    setTimeout(() => {
      console.log('menuCode', this.menuCode)
      console.log('buttonList', this.buttonList)
    }, 2000)
  },
  methods: {
    initData() {
      this.loadData()
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios
        .post(
          this.$apis.bondRecord.exportYxDepositNew,
          this.searchForm,
          {
            responseType: 'blob'
          }
        )
        .then(res => {
          if (res) {
            const disposition = res.headers['content-disposition']
            const fileName = disposition
              .substring(disposition.indexOf('filename'))
              .split('=')[1]
            this.downloadFile(res.data, fileName)
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    onAdd() {
      this.$router.push('/fundmanage/add?depositType=' + this.depositType + '&transactionType=' + this.transactionType)
    },
    onApproval(row) {
      this.$router.push('/fundmanage/approval?depositId=' + row.depositId + '&transactionType=' + this.transactionType + '&depositType=' + this.depositType)
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' }).then(res => {
        this.userList = res.list || []
      })
    },
    onDelete(row) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.bondRecord.deleteDataYxUserDepositNew, {
          depositId: row.depositId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.bondRecord.selectYxUserDepositNewByList, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>
